import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
import { type ControlVariant, controlClassName } from '../lib/control-styles'
import { useFieldControlProps } from '../lib/field-context'
export function Textarea({
  className,
  variant = 'outline',
  rows = 4,
  ...props
}: ComponentProps<'textarea'> & { variant?: ControlVariant }) {
  const field = useFieldControlProps(props)
  return (
    <textarea
      {...props}
      {...field}
      rows={rows}
      data-slot="textarea"
      className={cn(controlClassName(variant), 'h-auto min-h-24 resize-y py-3', className)}
    />
  )
}
